export const alertColorType = {
  Warning: '#faf202',
  Urgent: '#FFCC6C',
  Critical: '#ff5100',
  none: '#000000',
}
